// frontend/src/pages/ChangeVehicleCategory.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { readFormId, withForm } from '../utils/wizardForm';
import HeaderLogged from '../components/HeaderLogged';
import Footer from '../components/Footer';
import IrsMaintenanceBanner from "./IrsMaintenanceBanner";
const WEIGHT_CATEGORIES = [
  { letter: 'A', range: '55,000', tax: 100 },
  { letter: 'B', range: '55,001 - 56,000', tax: 122 },
  { letter: 'C', range: '56,001 - 57,000', tax: 144 },
  { letter: 'D', range: '57,001 - 58,000', tax: 166 },
  { letter: 'E', range: '58,001 - 59,000', tax: 188 },
  { letter: 'F', range: '59,001 - 60,000', tax: 210 },
  { letter: 'G', range: '60,001 - 61,000', tax: 232 },
  { letter: 'H', range: '61,001 - 62,000', tax: 254 },
  { letter: 'I', range: '62,001 - 63,000', tax: 276 },
  { letter: 'J', range: '63,001 - 64,000', tax: 298 },
  { letter: 'K', range: '64,001 - 65,000', tax: 320 },
  { letter: 'L', range: '65,001 - 66,000', tax: 342 },
  { letter: 'M', range: '66,001 - 67,000', tax: 364 },
  { letter: 'N', range: '67,001 - 68,000', tax: 386 },
  { letter: 'O', range: '68,001 - 69,000', tax: 408 },
  { letter: 'P', range: '69,001 - 70,000', tax: 430 },
  { letter: 'Q', range: '70,001 - 71,000', tax: 452 },
  { letter: 'R', range: '71,001 - 72,000', tax: 474 },
  { letter: 'S', range: '72,001 - 73,000', tax: 496 },
  { letter: 'T', range: '73,001 - 74,000', tax: 518 },
  { letter: 'U', range: '74,001 - 75,000', tax: 540 },
  { letter: 'V', range: 'over 75,000', tax: 550 },
];

const MONTHS = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

export default function ChangeVehicleCategory() {
  const { id: companyId } = useParams();
  const navigate = useNavigate();
  // Контекст поправки — из адреса (его кладёт BeginAmendedReturn)
  const [searchParams]     = useSearchParams();
  const submissionId       = searchParams.get('sid');
  const token              = localStorage.getItem('token');
  const prevSubmissionDate = searchParams.get('date');
  const prevFormId         = readFormId(searchParams);

  const [availableVins, setAvailableVins] = useState([]);
  const [vin, setVin]                     = useState('');
  const [oldCategory, setOldCategory]     = useState('');
  const [newCategory, setNewCategory]     = useState('');
  const [changeMonth, setChangeMonth]     = useState('');
  const [generalMonth, setGeneralMonth]   = useState('');
  const [changes, setChanges]             = useState([]);

  useEffect(() => {
    if (!submissionId) return;
    fetch(`/api/submissions/${submissionId}/vehicles/`, {
      headers: {
        'Content-Type':  'application/json',
        Authorization:   `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) throw new Error('VIN numbers Error');
        return res.json();
      })
      .then(data => setAvailableVins(data))
      .catch(console.error);
  }, [submissionId, token]);

  const handleVinChange = e => {
    const selected = e.target.value;
    setVin(selected);
    const veh = availableVins.find(v => v.vin === selected);
    setOldCategory(veh?.gross_vehicle_label || '');
    // сбрасываем
    setNewCategory('');
    setChangeMonth('');
  };

  // исключаем уже добавленные VIN
  const remainingVins = availableVins.filter(v =>
    !changes.some(chg => chg.VIN === v.vin)
  );

  // только новые категории > старой
  const oldIndex     = WEIGHT_CATEGORIES.findIndex(c => c.letter === oldCategory);
  const allowedCats  = WEIGHT_CATEGORIES.filter((_, idx) => idx > oldIndex);

  const handleAdd = () => {
    if (!vin || !newCategory || !changeMonth) return;
    setChanges(prev => [
      ...prev,
      { VIN: vin, OldCategory: oldCategory, NewCategory: newCategory, amendment_month: changeMonth }
    ]);
    // сброс полей
    setVin('');
    setOldCategory('');
    setNewCategory('');
    setChangeMonth('');
  };

  const handleRemove = idx => {
    setChanges(prev => prev.filter((_, i) => i !== idx));
  };

  const handleSave = () => {
    if (!prevFormId || !submissionId || !prevSubmissionDate) {
      alert('Missing context: previous form or submission not found. Please start the amendment again.');
      return;
    }
    if (!generalMonth) {
      alert('Please select the overall amended month');
      return;
    }
    const payload = {
      form2290:             parseInt(prevFormId, 10),
      prev_submission_id:   submissionId,
      change_type:          'TGW',
      prev_submission_date: prevSubmissionDate,
      amendment_month:      generalMonth,
      changes: changes.map(c => ({
        VIN:             c.VIN,
        'Old Category':  c.OldCategory,
        'New Category':  c.NewCategory,
        amendment_month: c.amendment_month
      }))
    };
    console.log(payload);
    fetch('/api/submission-detail/', {
      method:  'POST',
      headers: {
        'Content-Type':  'application/json',
        Authorization:   `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) throw new Error('Error');
        return res.json();
      })
      .then(() => navigate(withForm(`/company/${companyId}/amended-payment-and-submission`, prevFormId, { type: 'TGW' })))
      .catch(err => {
        console.error(err);
        alert('Error');
      });
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#E4F2C5E]">
      <HeaderLogged />
      <main className="flex-1 py-6 px-4">
        <div className="max-w-3xl mx-auto bg-white shadow-md p-6 rounded-lg">
          <h1 className="text-2xl font-semibold text-[#0F2C5E] mb-4">
            Change Vehicle Category
          </h1>

          {/* Overall Amended Month */}
          <div className="mb-6">
            <label className="block font-medium mb-1">
              Overall Amended Month <span className="text-red-500">*</span>
            </label>
            <select
              value={generalMonth}
              onChange={e => setGeneralMonth(e.target.value)}
              className="w-1/2 border p-2 focus:outline-none focus:ring-2 focus:ring-[#0F2C5E]"
            >
              <option value="">Select Month</option>
              {MONTHS.map(m => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
          </div>

          {/* Add Row */}
          <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 mb-6">
            {/* VIN */}
            <select
              value={vin}
              onChange={handleVinChange}
              className="col-span-2 border p-2 focus:outline-none focus:ring-2 focus:ring-[#0F2C5E]"
            >
              <option value="">Select VIN</option>
              {remainingVins.map(v => (
                <option key={v.id} value={v.vin}>
                  {v.vin}
                </option>
              ))}
            </select>
            {/* Current Category */}
            <input
              type="text"
              value={oldCategory}
              disabled
              placeholder="Current Category"
              className="border bg-gray-100 p-2"
            />
            {/* Per-VIN Month */}
            <select
              value={changeMonth}
              onChange={e => setChangeMonth(e.target.value)}
              disabled={!vin}
              className="border p-2 focus:outline-none focus:ring-2 focus:ring-[#0F2C5E] disabled:opacity-50"
            >
              <option value="">Month</option>
              {MONTHS.map(m => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
            {/* New Category */}
            <select
              value={newCategory}
              onChange={e => setNewCategory(e.target.value)}
              disabled={oldIndex < 0}
              className="border p-2 focus:outline-none focus:ring-2 focus:ring-[#0F2C5E] disabled:opacity-50"
            >
              <option value="">Select New Category</option>
              {allowedCats.map(c => (
                <option key={c.letter} value={c.letter}>
                  {c.letter} ({c.range})
                </option>
              ))}
            </select>
            {/* Add */}
            <button
              onClick={handleAdd}
              disabled={!vin || !newCategory || !changeMonth}
              className="sm:col-span-5 bg-[#0F2C5E] text-white py-2 rounded hover:bg-[#0F2C5E]/80 transition disabled:opacity-50"
            >
              Add Change
            </button>
          </div>

          {/* Список изменений */}
{/* Список изменений */}
          {changes.length > 0 ? (
            <ul className="space-y-2 mb-6">
              {changes.map((chg, i) => (
                <li
                  key={`${chg.VIN}-${i}`}
                  className="flex items-start justify-between border p-3 rounded space-x-4"
                >
                  {/* VIN растягивается на всё доступное место и не обрезается */}
                  <span className="flex-1 whitespace-normal">
                    <strong>VIN number:</strong> {chg.VIN}
                  </span>

                  <span className="w-1/5">
                    <strong>Old category:</strong> {chg.OldCategory}
                  </span>

                  <span className="w-1/5">
                    <strong>New category:</strong> {chg.NewCategory}
                  </span>

                  <span className="w-1/5">
                    <strong>Amended month:</strong>{' '}
                    {MONTHS.find(m => m.value === chg.amendment_month)?.label}
                  </span>

                  <button
                    onClick={() => handleRemove(i)}
                    className="text-red-600 hover:underline text-sm"
                  >
                    Remove
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500 mb-6">No changes added yet.</p>
          )}

          {/* Actions */}
          <div className="flex justify-between">
            <button
              onClick={() => navigate(-1)}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition"
            >
              Back
            </button>
            <button
              onClick={handleSave}
              disabled={!changes.length || !generalMonth}
              className={`px-4 py-2 rounded text-white transition ${
                changes.length && generalMonth
                  ? 'bg-[#0F2C5E] hover:bg-[#0F2C5E]/80'
                  : 'bg-gray-400 cursor-not-allowed'
              }`}
            >
              Save Changes
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
